import styles from './IconDefault.module.scss';

export function IconDocument() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 4C8.34315 4 7 5.34315 7 7V35C7 36.6569 8.34315 38 10 38H33C34.6569 38 36 36.6569 36 35V14.2426C36 13.447 35.6839 12.6839 35.1213 12.1213L27.8787 4.87868C27.3161 4.31607 26.553 4 25.7574 4H10ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14H18.5C19.0523 14 19.5 13.5523 19.5 13C19.5 12.4477 19.0523 12 18.5 12H11ZM11 17C10.4477 17 10 17.4477 10 18C10 18.5523 10.4477 19 11 19H28C28.5523 19 29 18.5523 29 18C29 17.4477 28.5523 17 28 17H11ZM11 22C10.4477 22 10 22.4477 10 23C10 23.5523 10.4477 24 11 24H28C28.5523 24 29 23.5523 29 23C29 22.4477 28.5523 22 28 22H11ZM11 27C10.4477 27 10 27.4477 10 28C10 28.5523 10.4477 29 11 29H28C28.5523 29 29 28.5523 29 28C29 27.4477 28.5523 27 28 27H11Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M24 9V3.41421C24 2.52331 25.0771 2.07714 25.7071 2.70711L33.2929 10.2929C33.9229 10.9229 33.4767 12 32.5858 12H27C25.3431 12 24 10.6569 24 9Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M5 32V33C5 34.6569 6.34315 36 8 36H31C32.6569 36 34 34.6569 34 33V16M5 22V5C5 3.34315 6.34315 2 8 2H24M24 2V2C24.6403 2 25.2542 2.25421 25.707 2.70696C27.2621 4.2621 31.0589 8.05888 33.7942 10.7942C33.9268 10.9268 34 11.1054 34 11.2929V11.2929C34 11.6834 33.6834 12 33.2929 12H27C25.3431 12 24 10.6569 24 9V2Z"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="5"
				cy="25.1875"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="5"
				cy="28.5"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
